/*
 * @Author: mayanxia 
 * @Date: 2022-08-22 16:41:09 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2022-08-24 10:16:22
 */

<!--增加补水操作员-->
<template>
    <a-modal
        :title="title"
        :width="1000"
        :visible="visible"
        :confirmLoading="confirmLoading"
        :okButtonProps="{ props: {disabled: disableSubmit} }"
        :maskClosable="maskClosable"
        @ok="handleOk"
        @cancel="handleCancel"
        :cancelText="$t('关闭')">

        <a-spin :spinning="confirmLoading">
            <div class="form-contain">
                <a-tabs v-model="activeKey" @change="changeTab">
                    <a-tab-pane key="1" :tab="$t('审核')">
                        <a-divider orientation="left">{{ $t('审核信息') }}</a-divider>
                        <a-form-model ref="formModal" :model="formModel" :rules="rules" :colon="false" layout="vertical">
                            <div>
                                <a-row :gutter="24">
                                    <a-col :xl="8" :lg="7" :md="8" :sm="24" :offset="8">
                                        <a-form-model-item :label="$t('审核状态')" prop="auditStatus">
                                            <a-radio-group v-model="formModel.auditStatus">
                                                <a-radio  :value="1">{{ $t('审核不通过') }}</a-radio>
                                                <a-radio :value="2">{{ $t('审核通过') }}</a-radio>
                                            </a-radio-group>
                                        </a-form-model-item>
                                    </a-col>
                                    <a-col :xl="24" :lg="24" :md="24" :sm="24">
                                        <a-form-model-item :label="$t('审核意见')" prop="auditDetail">
                                            <a-textarea v-model="formModel.auditDetail" rows="3" :placeholder="$t('请输入备注')" style="width:100%"/>
                                        </a-form-model-item>
                                    </a-col>
                                </a-row>
                            </div>
                        </a-form-model>
                        <a-divider orientation="left">{{ $t('用户信息') }}</a-divider>
                        <detail-list>
                            <detail-list-item :term="$t('用户编号')">{{vocationDetail.userId}}</detail-list-item>
                            <detail-list-item :term="$t('用户姓名')">{{vocationDetail.userName}}</detail-list-item>
                            <detail-list-item :term="$t('手机号码')">{{vocationDetail.userPhone}}</detail-list-item>
                            <detail-list-item :term="$t('表编号')">{{vocationDetail.meterId}}</detail-list-item>
                            <detail-list-item :term="$t('用户地址')">{{vocationDetail.userAddr}}</detail-list-item>
                            <detail-list-item :term="$t('用水单价(元)')">{{vocationDetail.userPriceTotal}}</detail-list-item>
                            <detail-list-item :term="$t('价格名称')">{{vocationDetail.userPriceName}}</detail-list-item>
                            <detail-list-item :term="$t('单次最大购买金额(元)')">{{vocationDetail.maxBuyOnce}}</detail-list-item>
                            <detail-list-item :term="$t('最大囤积金额(元)')">{{vocationDetail.maxHording}}</detail-list-item>
                        </detail-list>
                        <a-divider orientation="left">{{ $t('补水申请信息') }}</a-divider>
                        <detail-list>
                            <detail-list-item :term="$t('申请时间')">{{model.createTime}}</detail-list-item>
                            <detail-list-item :term="$t('申请人')">{{model.createBy}}</detail-list-item>
                            <detail-list-item :term="$t('订单号')">{{vocationDetail.orderId}}</detail-list-item>
                            <detail-list-item :term="$t('补水前余额(元)')">{{vocationDetail.userAccountNum}}</detail-list-item>
                            <detail-list-item :term="$t('交易方式')">{{vocationDetail.payWay== 1?$t('营业厅'):'--'}}</detail-list-item>
                            <detail-list-item :term="$t('计费类型')">{{vocationDetail.payType== 1?$t('按金额'):vocationDetail.payType== 2?$t('按吨数'):'--'}}</detail-list-item>
                            <detail-list-item :term="vocationDetail.payType== 1?$t('补水金额(元)'):vocationDetail.payType== 2?$t('补水吨数(吨)'):''">
                                {{vocationDetail.payType== 1?vocationDetail.buyWaterMoney:vocationDetail.payType== 2?vocationDetail.buyWaterCount:'--'}}
                            </detail-list-item>
                            <detail-list-item :term="$t('实际补水金额(元)')">{{vocationDetail.buyWaterMoney}}</detail-list-item>
                            <detail-list-item :term="$t('补水备注')" :itemCol="1">{{vocationDetail.remark}}</detail-list-item>
                        </detail-list>
                    </a-tab-pane>
                    <a-tab-pane key="2" :tab="$t('补水记录')">
                        <a-table 
                            :columns="columns"
                            :data-source="dataSource"
                            rowKey='id'
                            size='middle'
                            :scroll="{ x: true }"
                            :pagination="ipagination"
                            @change="handleTableChange"
                            >
                                <span slot="userPriceSlot" slot-scope="text, record">
                                <span v-if="record.userPriceName"> {{record.userPriceName}}({{record.userPriceTotal?record.userPriceTotal + $t('元'): '--'}})</span>
                                <span v-else>--</span>
                                </span>
                            </a-table>
                    </a-tab-pane>
                </a-tabs>
            </div> 
        </a-spin>
    </a-modal>
</template>

<script>
    import DetailList from '@/components/tools/DetailList'
    const DetailListItem = DetailList.Item
    import { httpAction,getAction } from '@/api/manage'
    import {payWayObj,payTypeObj} from '@/utils/constants/commonConstant'
    import {isUndefined} from'@/utils/validate'

    const dataSource = [];
    export default {
        name: 'softwareModal',
        components: {
            DetailList,
            DetailListItem
        },
        props: {
            //表单禁用
            disabled: {
                type: Boolean,
                default: false,
                required: false
            }
        },
        data () {
            return {
                title:this.$t('操作'),
                visible: false,
                disableSubmit:false,
                maskClosable:false,
                model: {},
                confirmLoading: false,
                formModel: {auditStatus: 2},
                url: {
                    add: "/auditprocess/auditUserLink/add",
                    edit: "/auditprocess/auditUserLink/edit",
                    doFreeAuditPayTask: '/auditprocess/auditRecord/doFreeAuditPayTask',
                    UserRecordList:"/jeecg-charge/meter/meterUserPayRecord/list", //缴费记录查询接口
                },
                vocationDetail: {},
                ipagination:{
                    current: 1,
                    pageSize: 10,
                    pageSizeOptions: ['10', '20', '30'],
                    showTotal: (total, range) => {
                    return range[0] + "-" + range[1] + " " + this.$t('共{total}条', { total })
                    },
                    showQuickJumper: true,
                    showSizeChanger: true,
                    total: 0
                },
                dataSource,
                activeKey:'1',
            }
        },
        computed: {
            rules(){
                return {
                    auditStatus:[{ required: true, message: this.$t('请选择审核状态')}]
                }
            },
            columns() {
                return [
                    {
                    title: this.$t('用户姓名'),
                    dataIndex: 'userName',
                    align:'center'
                    },{
                    title: this.$t('购买金额(元)'),
                    dataIndex: 'userPayAccountNum',
                    align:'center'
                    },{
                    title: this.$t('缴费途径'),
                    dataIndex: 'payWay',
                    align:'center',
                    customRender: (t,r,index) => {
                        if(isUndefined(payWayObj[t])) {
                        return this.$t('其他')
                        }
                        return this.$t(payWayObj[t])
                    }
                    },{
                    title: this.$t('价格信息'),
                    dataIndex: 'userPrice',
                    align:'center',
                    scopedSlots: { customRender: 'userPriceSlot' },
                    },{
                    title: this.$t('补水量(吨)'),
                    dataIndex: 'payWaterNum',
                    align:'center'
                    },{
                    title: this.$t('订单号'),
                    dataIndex: 'payOrderId',
                    align:'center'
                    },{
                    title: this.$t('操作员'),
                    dataIndex: 'createBy',
                    align:'center'
                    },{
                    title: this.$t('充值日期'),
                    dataIndex: 'createTime',
                    align:'center'
                    },{
                    title: this.$t('剩余金额(元)'),
                    dataIndex: 'userNowAccountNum',
                    align: 'center'
                    },{
                    title: this.$t('备注'),
                    dataIndex: 'payRemark',
                    align:'center'
                    },/*{
                    title:'操作类型',
                    dataIndex:'userAccountPayType',
                    fixed:"right",
                    align:'center',
                    customRender:function (t,r,index) {
                        if(isUndefined(payTypeObj[t])) {
                        return "其他"
                        }
                        return payTypeObj[t]
                    }
                    },*/
                ]
            },
        },
        created () {
        
        },
        methods: {
            handleOk() {
                console.log("点击提交")
                // 触发表单验证
                this.$refs.formModal.validate(valid => {
                    if(valid) {
                      this.confirmLoading = true;
                      let httpurl = this.url.doFreeAuditPayTask;
                      let method = 'put';
                      let params = {...this.formModel};
                      params.id = this.model.id
                        httpAction(httpurl,params,method).then((res) => {
                          this.confirmLoading = false
                          if(res.success){
                              this.$message.success(res.message)
                              this.$emit('ok')
                              this.close()
                          }else{
                              this.$message.warning(res.message)
                          }
                      })
                    }else{
                        return false
                    }
                })
            },
            add() {
                this.edit({});
            },
            edit (record) { 
                this.visible = true;
                this.model = Object.assign(this.model,record)
                if(this.model.vocationDetail) {
                    this.vocationDetail = JSON.parse(this.model.vocationDetail)
                }
            },
            close () {
                this.$emit('close');
                this.$refs.formModal.resetFields()
                this.model = this.$options.data.call(this).model
                this.formModel = this.$options.data.call(this).formModel
                this.disableSubmit = false;
                this.visible = false;
                this.activeKey = '1';
            },

            handleCancel () {
                this.close();
            },
            handleTableChange(pagination, filters, sorter) {
                if (Object.keys(sorter).length > 0) {
                this.isorter.column = sorter.field;
                this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
                }
                this.ipagination = pagination;
                this.queryUserRecordList();
            },
            queryUserRecordList() {  //缴费记录查询
                let params = {}
                params.pageNo = this.ipagination.current;
                params.pageSize = this.ipagination.pageSize;
                params.userKeyId = this.vocationDetail.userKeyId;
                params.userAccountPayType = 3;
                getAction(this.url.UserRecordList, params).then((res) => {
                    if(res.success){
                    this.dataSource = res.result.records;
                    this.ipagination.total = res.result.total;
                }
                })
            },
            changeTab(e) {
                if(this.activeKey == 2) {
                    this.queryUserRecordList()
                }
            },
        }
    }
</script>
<style scoped>
    .ant-form-item >>> .ant-select{
    width: 100%;
    }
    .span {
    margin: 8px;
    }
    .detail-list >>> .content{
    line-height: normal;
    }
</style>